export default __webpack_public_path__ + "static/media/logo.b3958bb6.png";